import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { comparison, processSteps } from '../data/site';
export function Financing() {
  return <section id="financiamiento" className="bg-white py-20 lg:py-28" data-id="element-111" data-mp="6vv7pm04phbg">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-112" data-mp="buolzgn8pcco">
        <SectionHeading title="Financiamiento directo, sin banco" description="Aprobación en menos de 24 horas, sin historial crediticio y sin trámites interminables." data-id="element-113" data-mp="bsc413hhf1zm" />

        {/* Tabla comparativa */}
        <div className="mt-14 overflow-x-auto" data-id="element-114" data-mp="3k9q82nzpmw51">
          <table className="w-full min-w-[560px] border-collapse text-left" data-id="element-115" data-mp="3k8x7k4rch2vc">
            <caption className="sr-only" data-id="element-116" data-mp="3p1qe8y6dila2">Comparación entre un banco y ARCOPORACION</caption>
            <thead data-id="element-117" data-mp="2rkjbhujtggmf">
              <tr data-id="element-118" data-mp="2rl1ct5lc5l17">
                <th scope="col" className="w-1/3 pb-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-forest-900/50" data-id="element-119" data-mp="2rjggpbjdhu18">
                  Criterio
                </th>
                <th scope="col" className="pb-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-forest-900/50" data-id="element-120" data-mp="2yul3fjrzc2kt">
                  Banco tradicional
                </th>
                <th scope="col" className="pb-4" data-id="element-121" data-mp="2p488qyqgat0y">
                  <span className="inline-block bg-forest-900 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-122" data-mp="2p2x6x4gkfvch">
                    ARCOPORACION
                  </span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-123" data-mp="2b4qrd4fhii1m">
              {comparison.map(row => <tr key={row.criterio} className="border-t border-forest-900/10" data-id="element-124" data-mp="265vvp1wf4z03">
                  <th scope="row" className="py-5 pr-4 text-[14px] font-medium text-forest-900" data-id="element-125" data-mp="224tx8nabsqz6">
                    {row.criterio}
                  </th>
                  <td className="py-5 pr-4 align-top" data-id="element-126" data-mp="4eitwlpqz789">
                    <span className="flex items-start gap-2 text-[14px] text-forest-900/55" data-id="element-127" data-mp="dqltvsm38dk">
                      <XIcon size={17} className="mt-0.5 shrink-0 text-[#a8332c]" strokeWidth={2.5} data-id="element-128" data-mp="1twfznecynpvf" />
                      {row.banco}
                    </span>
                  </td>
                  <td className="bg-sand py-5 pl-4 pr-4 align-top" data-id="element-129" data-mp="1yoqy0cs1z3lv">
                    <span className="flex items-start gap-2 text-[14px] font-medium text-forest-900" data-id="element-130" data-mp="1kx2n2ctjil6h">
                      <CheckIcon size={17} className="mt-0.5 shrink-0 text-gold" strokeWidth={2.5} data-id="element-131" data-mp="1oxcvrx8pvpp1" />
                      {row.arco}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pasos del proceso */}
        <div className="mt-20" data-id="element-132" data-mp="23lpvn5axdsot">
          <h3 className="font-display text-2xl text-forest-900 md:text-3xl" data-id="element-133" data-mp="28ku1blyn58ae">
            Cuatro pasos para ser dueño
          </h3>
          <ol className="mt-9 grid gap-px bg-forest-900/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-134" data-mp="s5srwayfh47j">
            {processSteps.map((step, index) => <Reveal key={step.titulo} as="li" delay={index * 0.05} className="h-full bg-white p-7" data-id="element-135" data-mp="x3uayvvut3j0" data-mpi={index}>
                <span className="font-display text-4xl text-gold-400" data-id="element-136" data-mp="kn1nq3ukau2j">{index + 1}</span>
                <p className="mt-3 text-[14px] font-semibold uppercase tracking-[0.1em] text-forest-900" data-id="element-137" data-mp="ylri3bpzyfn7">
                  {step.titulo}
                </p>
                <p className="mt-2 text-[13px] leading-relaxed text-forest-900/65" data-id="element-138" data-mp="5y5fa5olff1e">
                  {step.detalle}
                </p>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}